import DButton from '@/components/Global/DButton';
import GoogleIcon from '@/shared/icons/GoogleIcon';
import StarIcon from '@/shared/icons/StarIcon';
import { useChatbotStore } from '@/stores/chatbot/chatbotStore';
import BgImage from '@/assets/modal/signup_popup_background.png'
import { useSearchParams } from 'react-router-dom';

const BubblePopup = () => {
    //get search params that are after the ?
    const searchParams = new URLSearchParams(window.location.search);
    const kb_id = searchParams.get('kb_id');
    const token = searchParams.get('token');

    const setSaveSignUpBtn = useChatbotStore((state) => state.setSaveSignUpBtn);
  return  <div className="flex flex-col gap-v3-ms p-v3-ms mx-v3-xs mb-[10px] rounded-v3-xs"
        style={{
            backgroundImage: `url(${BgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        }}
    >
        <div className="bg-black w-[32px] h-[32px] flex justify-center items-center rounded-v3-ms shadow-sm">
            <StarIcon  className="text-white" />
         </div>
        <p className="text-base font-medium">
            Access Your Free Dante AI Agent
        </p>
        <p className="text-sm text-grey-50">
            Your custom AI Agent will be saved in your Dante AI account and ready to use for free.
        </p>
        <div className="flex items-center gap-v3-xs">
        <DButton
            fullWidth
            variant="dark"
            onClick={() => {
                window.open(`https://app.dante-ai.com/sign-up/?kb_id=${kb_id}&is_landing_page=True`, '_blank');
            }}
          >
            Sign Up with Email
          </DButton>
          <DButton
            fullWidth
            variant="dark"
            onClick={() => {
                window.open(`https://app.dante-ai.com/sign-up/?kb_id=${kb_id}&is_landing_page=True`, '_blank');
            }}
          >
            <GoogleIcon />
            Sign up with Google
          </DButton>

        </div>
    </div>
};

export default BubblePopup;

